import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { Checkbox, Bubble } from '@lt/components';
import { QuestionCircle } from '@lt/components/icons-react';

import ExtraPrice from '../ExtraPrice';
import { EXTRA_SCOPES } from '../../../../store/constants/extras';
import Icon from '../../../../../../components/Icon';

import type { IExtraItem } from '../../types';

const baseCls = 'checkout-service-item';

const LTExtraContentWrapper = ({ children, className = '' }): JSX.Element => (
  <div className={className}>
    <div style={{ marginTop: 3, marginRight: 8 }}>
      <Icon type="included" width="16px" height="16px" />
    </div>
    {children}
  </div>
);

const ExtraItem: FC<IExtraItem> = ({
  name,
  description = '',
  price,
  recommend = false,
  image,
  hashsum,
  selected = false,
  onChange = Function.prototype,
  children,
  isMobile = false,
  scope,
  tooltip,
}) => {
  const img = image ? { backgroundImage: `url(${image})` } : {};

  const itemCls = cn(baseCls, {
    [`${baseCls}--recommend`]: recommend,
  });

  const isLtExtra = scope === EXTRA_SCOPES.LEVEL_TRAVEL;

  const priceNode = (
    <ExtraPrice
      className={cn(`${baseCls}__price`, 'nowrap', {
        [`${baseCls}__price--active`]: selected && !isLtExtra,
      })}
      price={price}
    />
  );

  const ContentWrapper = isLtExtra ? LTExtraContentWrapper : Checkbox;

  return (
    <li className={itemCls} style={img}>
      {children}
      <div className={`${baseCls}__content`}>
        <ContentWrapper
          className={`${baseCls}__label checkout-checkbox`}
          id={hashsum}
          checked={selected}
          onChange={() => onChange({ hashsum, selected: !selected })}
        >
          <div className={`${baseCls}__description--container`}>
            {name}
            {!isMobile && priceNode}
            <p className={`${baseCls}__description`}>
              {description}
              {tooltip && (
                <Bubble text={tooltip} placement="bottom">
                  <QuestionCircle />
                </Bubble>
              )}
            </p>
          </div>
          {isMobile && priceNode}
        </ContentWrapper>
      </div>
    </li>
  );
};

export default ExtraItem;
